import {Box, Flex, Text} from 'exsportia-components'
import React, {FC} from 'react'

import {SelectedSession} from '../../../services/booking/forms/types'
import {ExsportiaIcon} from '../../../ui/components/exsportia-icon/exsportia-icon'
import {NO_USER_PHOTO} from '../../../utils/remote-content'

type SessionPreviewCardProps = {
  session: SelectedSession
  onRemove: () => void
  removeDisabled: boolean
  currency?: string
}

export const SessionPreviewCard: FC<SessionPreviewCardProps> = ({session, onRemove, removeDisabled}) => {
  const instructorName = session.instructors?.[0]?.name || ''
  const instructorImage = session.instructors?.[0]?.profileImage?.secure_url || NO_USER_PHOTO

  return (
    <Box
      p='12px 16px'
      border='1px solid #e2e8f0'
      borderRadius='12px'
      mb='8px'
    >
      <Flex
        justifyContent='space-between'
        alignItems='flex-start'
      >
        <Flex alignItems='baseline'>
          <Text settings={{fontSize: '16px', fontWeight: 'bold'}}>
            {session.time}
          </Text>
          <Text settings={{fontSize: '12px', color: '#718096', m: '0 0 0 6px'}}>
            {session.duration}min
          </Text>
        </Flex>
        {!removeDisabled && (
          <Box
            cursor='pointer'
            onClick={onRemove}
            p='4px'
            ml='8px'
          >
            <ExsportiaIcon
              icon='deleteIcon'
              color='notify'
              w={18}
              h={18}
            />
          </Box>
        )}
      </Flex>
      {session.className && (
        <Text settings={{fontSize: '14px', fontWeight: '600', color: '#1a202c', m: '4px 0 0 0'}}>
          {session.className}
        </Text>
      )}
      <Flex
        alignItems='center'
        justifyContent='space-between'
        mt='8px'
      >
        <Flex alignItems='center'>
          <Box
            as='img'
            src={instructorImage}
            width='32px'
            height='32px'
            borderRadius='50%'
            mr='8px'
          />
          <Text settings={{fontSize: '14px', color: '#4a5568'}}>{instructorName}</Text>
        </Flex>
      </Flex>
    </Box>
  )
}
